import request from '../../libs/request';

export default {
  get: (sellerId, queryParams, siteId) =>
    request(`api/v1/site/${siteId}/lojas${sellerId ? `/${sellerId}` : ''}`).get({ queryParams }),

  getNearest: (siteId, queryParams) => request(`api/v1/site/${siteId}/lojas/proximidade`).get({ queryParams }),
};
